import type { RouterOutputs } from '@/utils/api';
import { api } from '@/utils/api';

interface UseDeleteEventOptions {
    onSuccess?: () => void;
    onError?: (message?: string) => void;
}

export function useDeleteEvent(
    event: RouterOutputs['platoUser']['query']['events']['getEventById'],
    options: UseDeleteEventOptions = {},
) {
    const apiUtils = api.useUtils();

    const { mutate, ...deleteMutation } = api.platoUser.command.events.delete.useMutation({
        onSuccess: () => {
            if (event) {
                apiUtils.platoUser.query.events.getList.invalidate();
            }

            if (event?.customer) {
                apiUtils.platoUser.query.events.getUpcomingCustomerEvents.invalidate({
                    customerId: event.customer.customerId,
                });
            }

            options.onSuccess?.();
        },
        onError: (error) => {
            options.onError?.(error instanceof Error ? error.message : String(error));
        },
    });

    return {
        ...deleteMutation,
        mutate: () => {
            if (!event || deleteMutation.isLoading) return;

            mutate({
                eventId: event.event_id,
            });
        },
    };
}
